<template>
  <div class="searchbox">
    <div class="search">
      <div class="search__input" :class="{'search__input--focus':isFocus}" @click.stop="focusSearch">
        <span class="search__input__icon__left"><i class="icon-search"></i></span>
        <input ref="input" type="text" class="search__input__search subhead"
          @focus="onFocus" @keyup.enter="submit" v-model="searchText" placeholder="Search" required>
        <span @click.stop="clear" v-if="searchText" class="search__input__icon__right"><i class="icon-clear"></i></span>
      </div>
      <!-- <div v-if="isFocus && searchText != '' && filteredData.length > 0" class="search__menu">
        <ul class="search__menu__item">
          <li v-for="(item, index) in filteredData" :key="item.id"
            @mouseover="selectedIndex(index)" :class="{selected: selected == index}">
            <div @click.stop="select(item)">
              <span class="bold">{{ boldWord(item) }}</span>{{ sliceWord(item) }}<span v-if="item.detail">, {{ item.detail }}</span>
            </div>
          </li>
        </ul>
      </div> -->
      <!-- NOTE add back condition !user.admin to v-if in div search__menu for v.4.0 -->
      <div v-if="isFocus" class="search__menu">
        <template>
          <div class="search__menu__subtitle">Search our categories</div>
          <div class="search__menu__box">
            <div @click.stop="select(item)" class="search__menu__box__item" v-for="item in collections" :key="item.id">
              {{ item.type }}
            </div>
          </div>
          <!-- <div class="search__menu__subtitle">Recommended locations</div>
          <div class="search__menu__box">
            <div class="search__menu__box__item" v-for="item in recommended" :key="item.id"
            @click.stop="redirectWithFilter(item)">
              {{ item.location }}
            </div>
          </div>
          <div class="search__menu__subtitle">Your recent search</div>
          <ul class="search__menu__item">
            <li v-for="item in recent" :key="item.id" class="search__menu__item__recent">
              <div @click.stop="select(item)"> 
                {{ item.location }}<span v-if="item.detail">, {{ item.detail }}</span>
              </div>
            </li>
          </ul> -->
        </template>
      </div>
    </div>
    <div class="searchMobile">
      <div class="searchMobile__icon" @click.stop="toggle">
        <i class="icon-search"></i>
      </div>
      <modal v-if="isOpen" :title="`Search`" @modal-close="toggle"> 
        <div slot="content" class="searchMobile__popup">
          <div class="searchMobile__popup__body">
            <div class="search__input" :class="{'search__input--focus':isFocus}" @click.stop="focusSearch">
              <span class="search__input__icon__left"><i class="icon-search"></i></span>
              <input @keyup.enter="submit" ref="input" v-model="searchText" type="text" class="search__input__search subhead"
                @focus="onFocus" @blur="onBlur" placeholder="Search" required>
              <span @click.stop="clear" v-if="searchText" class="search__input__icon__right"><i class="icon-clear"></i></span>
            </div>
            <div v-if="false" class="search__menu">
              <ul class="search__menu__item">
                <li @click.stop="select(item)" v-for="(item, index) in filteredData" :key="item.id"
                  @mouseover="selectedIndex(index)" :class="{selected: selected == index}">
                  <span class="bold">{{ boldWord(item) }}</span>{{ sliceWord(item) }}<span v-if="item.detail">, {{ item.detail }}</span>
                </li>
              </ul>
            </div>
             <!-- NOTE add back condition !user.admin to v-if in div search__menu for v.4.0 -->
            <div class="search__menu">
              <template>
                <div class="search__menu__subtitle">Search our categories</div>
                <div class="search__menu__box">
                  <div @click.stop="select(item)" class="search__menu__box__item" v-for="item in collections" :key="item.id">
                    {{ item.type }}
                  </div>
                </div>
                <!-- <div class="search__menu__subtitle">Recommended locations</div>
                <div class="search__menu__box">
                  <div class="search__menu__box__item" v-for="item in recommended" :key="item.id"
                  @click.stop="redirectWithFilter(item)">
                    {{ item.location }}
                  </div>
                </div>
                <div class="search__menu__subtitle">Your recent search</div>
                <ul class="search__menu__item">
                  <li v-for="item in recent" :key="item.id" class="search__menu__item__recent">
                    <div @click.stop="select(item)"> 
                      {{ item.location }}<span v-if="item.detail">, {{ item.detail }}</span>
                    </div>
                  </li>
                </ul> -->
              </template>
            </div>
          </div>  
        </div>
      </modal> 
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Media from 'vue-media'
import Modal from '@/components/Modal'
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'adx-search',
  components: {
    'media': Media,
    'modal': Modal
  },
  computed: {
    ...mapGetters({
      account: 'account'
    })
  },
  mounted() {
    this.user.admin = this.account.isSuperuser
    Vue.$broker.$on('app-click', this.blurSearch.bind(this))
  },
  data() {
    return {
      search: '',
      searchText: '',
      filteredData: [],
      isFocus: false,
      isShown: false,
      selected: 0,
      isOpen: false,
      isLoading: false,
      user: {
        admin : null
      },
      list: [ 
        {
          "id": 0,
          "location": "Kemanggisan",
          "detail": "Jakarta Pusat",
        },
        {
          "id": 1,
          "location": "Kemayoran",
          "detail": "Jakarta Utara"
        },
        {
          "id": 2,
          "location": "Ancol",
          "detail": "Jakarta Timur"
        },
        {
          "id": 3,
          "location": "Grogol",
          "detail": "Jakarta Barat"
        },
        {
          "id": 4,
          "location": "Kemang",
          "detail": "Jakarta Selatan"
        },
      ],
      recent: [ 
        {
          "id": 0,
          "location": "Kemanggisan",
          "detail": "Jakarta Pusat",
        },
        {
          "id": 1,
          "location": "Kemayoran",
          "detail": "Jakarta Utara"
        },
        {
          "id": 2,
          "location": "Ancol",
          "detail": "Jakarta Timur"
        }
      ],
      recommended: [
        {
          "id": 0,
          "value": "JKT",
          "location": "Jakarta",
        },
        {
          "id": 1,
          "value": "BDG",
          "location": "Bandung",
        },
        {
          "id": 2,
          "value": "BGR",
          "location": "Bogor",
        },
        {
          "id": 3,
          "value": "YGKT",
          "location": "Yogyakarta",
        },
      ],
      collections: [
        {
          "id": 0,
          "value": "BU",
          "link": "spbu",
          "type": "SPBU",
        },
        {
          "id": 1,
          "value": "ML",
          "link": "malls",
          "type": "Malls",
        },
        {
          "id": 2,
          "value": "LS",
          "link": "lifestyle",
          "type": "Lifestyle",
        },
        {
          "id": 3,
          "value": "AR",
          "link": "airport",
          "type": "Airport",
        },
      ]
    }
  },
  updated() {
    
  },
  methods: {
    focusSearch() {
      this.$refs.input.focus()
    },
    blurSearch() {
      if (this.$refs.input) {
        this.$refs.input.blur()
        this.onBlur()
      }
    },
    onFocus() {
      this.isFocus = true
      let value = this.$refs.input.value
      if (value) {
        this.setSearchText(value)
      }
    },
    onBlur() {
      this.isFocus = false
    },
    filterData() {
      let searchLength = this.searchText.length
      let data = this.list.filter((data) => {
        let subStrLocation = data.location.toLowerCase().substr(0, searchLength)
        return subStrLocation == this.searchText.toLowerCase()
      })
      this.filteredData = data
      if (this.filteredData.length > 0) {
        this.selected = 0
      } else {
        this.selected = null
      }
    },
    setSearchText(value) {
      this.searchText = value
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    clear() {
      this.setSearchText('')
      this.$refs.input.value = ''
      this.resetFilteredData()
    },
    redirectWithFilter(item) {
      this.$router.push({ name: item.link});
    },
    redirectWithName(item){
      this.$router.push({ path: `/category/${item.link}`});
    },
    select(item) {
      this.isOpen = false
      this.isFocus = false
      if (this.selected !== null) {
        this.$emit('selected', item)
         if (this.user.admin){
           this.redirectWithName(item)
         } else {
           this.redirectWithFilter(item)
         }
      }
    },
    resetFilteredData() {
      this.filteredData = []
    },
    selectedIndex(index) {
      if (this.selected !== null) this.selected = index
    },
    boldWord(item) {
      if (item.id !== null) return item.location.slice(0, this.searchText.length)
    },
    sliceWord(item) {
      if (item.id !== null) {
        return item.location.slice(this.searchText.length)
      }
      return item.location
    },
    searchDevices(ev) {
      this.search = this.$refs.input.value
      if (!this.search) {
        this.resetFilteredData()
      }
      if ((ev.keyCode == 38 || ev.keyCode == 40 || ev.keyCode == 13) && this.isFocus == true) {
        if (this.search !== '') {
          if (ev.keyCode == 38 && (this.selected !== 0 && this.selected !== null)) {
            this.selected --
          } else if (ev.keyCode == 40 && (this.selected !== this.filteredData.length - 1
                    && this.selected !== null)) {
            this.selected ++
          } else if (ev.keyCode == 13 && this.selected !== null) {
            this.$refs.input.blur()
            this.select(this.filteredData[this.selected])
          }
        }
      } else if (ev.keyCode == 27) {
        this.blurSearch()
        this.clear()
      } else {
        var time = 800
        if (ev.keyCode == 13) {
          time = 0
        }
        
        setTimeout(() => {
          if (this.search) {
            this.setSearchText(this.search)
            this.filterData()
          } else {
            this.clear()
          }
        }, time) 
      }
    },
    submit() {
      if (this.searchText.trim() != '') {
        this.isOpen = false
        this.isFocus = false
        this.searchText = this.searchText.trim()
        if(this.$route.name == 'resultsgroup'){
          Vue.$broker.$emit("app-search", this.searchText);
          this.$router.push({ query: { search: this.searchText } })
        } else if (this.$route.name == 'resultsgroupV2'){
          Vue.$broker.$emit("app-search", this.searchText);
          this.$router.push({ query: { search: this.searchText } })
        } else {
          if (this.user.admin){
            this.$router.push({ name: 'resultsgroupV2', query: { search: this.searchText } })
          } else {
            this.$router.push({ name: 'resultsgroup', query: { search: this.searchText } })
          }
        }
      }
    }
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>